import React, { useMemo } from 'react';
import { Mesh } from 'three';

import { degreesToSlope } from '@paragon/geometry-library';
import { Point3D } from '@paragon/three-shared';

import { SLOPE_CAP } from '../hooks/useMousePositionWithBasicInsertionSnapping';
import { LabelVisual } from '../util/LabelVisual';
import { useDimensionLabelOptions } from './dimensionStyles';

interface Props {
  readonly degrees: number;
  readonly position: Point3D;
  readonly visible?: boolean;
  readonly onTextSync?: (troika: Mesh) => void;
}

// Past SLOPE_CAP (including vertical) the rise over 12 is too large to be meaningful, so we show degrees instead.
export function formatSlope(degrees: number) {
  const slope = degreesToSlope(degrees);

  return Math.abs(slope) > SLOPE_CAP
    ? `${Math.round(Math.abs(degrees) * 10) / 10}°`
    : `${Math.round(slope * 100) / 100} / 12`;
}

export function SlopeLabel({ degrees, position, visible, onTextSync }: Props) {
  const text = useMemo(() => formatSlope(degrees), [degrees]);
  const labelOptions = useDimensionLabelOptions('standard');

  return (
    <LabelVisual
      {...labelOptions}
      fontSize={5}
      visible={visible}
      onTextSync={onTextSync}
      position={[position.x, position.y, position.z]}
    >
      {text}
    </LabelVisual>
  );
}
